"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionTitle = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.SectionTitle = styled_components_1.default.h2.withConfig({ displayName: "SectionTitle", componentId: "sc-16a5on7-0" })(["color:#4b7892;margin-bottom:20px;font-size:30px;text-align:center;padding-top:60px;"]);
